import React, { memo, forwardRef } from "react";

export interface CityDeliveryDispatchWorkflowSectionProps {
    titleText: string;
    titleAction?: React.ReactNode;
    onTitleActionClick?: () => void;
    content: React.ReactNode;
}

const CityDeliveryDispatchWorkflowSection = forwardRef<
    HTMLDivElement,
    CityDeliveryDispatchWorkflowSectionProps
>((props, ref) => {
    return (
        <div
            className="city-delivery-dispatch-workflow__section"
            ref={ref ?? null}
        >
            <div className="city-delivery-dispatch-workflow__section__header">
                <div className="city-delivery-dispatch-workflow__section__header__title">
                    {props.titleText}
                </div>
                {props.titleAction && (
                    <div
                        className="city-delivery-dispatch-workflow__section__header__action"
                        onClick={props.onTitleActionClick}
                    >
                        {props.titleAction}
                    </div>
                )}
            </div>
            <div className="city-delivery-dispatch-workflow__section__content">
                {props.content}
            </div>
        </div>
    );
});

export default memo(CityDeliveryDispatchWorkflowSection);